<template lang="pug">
  .chooseUserDialog
    .tip {{$t('user_account_choose_tip')}}
    el-table(:data="tableData" @row-click="handleRowClick")
      el-table-column(:label="$t('ID')" prop='userId')
        template(slot-scope="scope")
          el-radio(:label="scope.row.userId" v-model="userId")
      el-table-column(:label="$t('user_username')" prop='userName')
      el-table-column(:label="$t('user_mainSubAccount')" prop='accountType')
        template(slot-scope="scope")
          span {{$t(`common_accountType_${scope.row.accountType}`)}}
    .dialog-footer(slot="footer")
      el-button(@click="cancel") {{$t('common_cancelButtonText')}}
      el-button(type="primary" @click="confirmed()") {{$t('common_confirmButtonText')}}
  </template>
  <script>
  import {mapState} from 'vuex'
  import { dialogCommon } from '@/mixin'
  export default {
    name: 'chooseUserDialog',
    mixins: [dialogCommon],
    data () {
      return {
        tableData: [],
        userId: '',
      }
    },
    computed: {
      ...mapState('home', ['dialog']),
    },
    created() {
      this.tableData = this.dialog.componentData.data
      this.userId = this.tableData[0].userId
    },
    methods: {
      handleRowClick(row, event, column) {
        this.userId = row.userId
      },
      confirmed () {
        this.dialog.componentData.callback && this.dialog.componentData.callback({
          userId: this.userId,
        })
        this.dialogHide(true)
      },
      cancel () {
        this.dialogHide(false)
        this.dialog.componentData.onCancel && this.dialog.componentData.onCancel()
      },
    },
  }
  </script>
  <style lang="scss" scoped>
  .el-checkbox-button__inner, .el-radio {
    user-select: unset;
  }
  .dialog-footer {
    margin-top: 20px;
  }
  </style>

